import { withAuth } from '../../../system-utils/api-utils';
import { constructGetShortTermTokenApiUrl } from './urls';
import { getSessionManager } from '../../../authorisation-utils/session-manager';

/**
 * Gets a Short Term Token
 * @returns
 */
export const postGenerateShortTermToken = (partnerCode: string) =>
  withAuth<{ token: string }>(({ headers }) =>
    fetch(constructGetShortTermTokenApiUrl(partnerCode), {
      method: 'POST',
      headers,
      body: JSON.stringify({
        context: 'CLIENT',
      }),
    }),
  ).then(resp => {
    // TODO: test logic
    if (resp.status === 200) {
      getSessionManager().clearSession();
    }
    return resp;
  });
